import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={26.213}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22346 22791"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:579.675}.fil0{fill:#2b2a29;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528323500112">
        <path
          d="M7006 19844c187 267 374 533 370 767-2 156-83 273-168 397-44 64-89 131-121 202-40 90-61 192-64 291-3 105 13 207 45 291 62 157 186 259 257 313l84 64-67 137-73-56c-78-59-234-179-316-387-41-108-62-237-58-368 4-124 30-252 80-363 37-85 88-158 137-230 69-100 135-197 136-294 3-171-167-414-338-657v-1l96-106zM15019 19883c187 267 374 533 370 767-3 156-83 273-168 397-44 64-90 131-122 202-40 90-60 192-63 291-3 105 13 207 45 291 62 157 186 259 256 313l84 63-67 138-72-55c-79-60-235-180-316-388-42-108-62-237-58-368 3-124 29-252 79-364 38-84 89-157 137-228 69-102 135-198 137-295 2-171-168-415-338-657l-1-1 97-106zM9827 19843l2 1c186 267 373 533 369 767-3 156-83 273-168 397-44 64-89 131-121 202-41 90-61 192-64 291-3 105 13 207 45 291 62 157 187 259 257 313l83 64-67 137-72-56c-78-59-235-179-316-387-42-108-62-237-58-368 3-124 29-252 80-363 37-85 88-158 136-230 69-100 135-197 137-294 3-171-168-414-338-657l25-27 70-81zM17840 19882l1 1c187 267 373 533 369 767-2 156-82 273-167 397-44 64-90 131-122 202-40 90-60 192-63 291-4 105 12 207 45 291 61 157 186 259 256 313l84 63-67 138-73-55c-78-60-234-180-315-388-42-108-63-237-59-368 4-124 30-252 80-364 38-84 88-157 137-228 69-102 135-198 137-295 2-171-168-414-338-657l24-28 71-80zM4185 19844c187 267 373 533 370 767-3 156-84 273-168 397-45 64-90 131-122 202-40 90-61 192-64 291-3 105 13 207 46 291 64 166 199 269 267 321l73 56-67 137-73-56c-78-59-234-179-315-387-42-108-63-237-59-368 4-124 30-252 80-363 38-85 88-158 136-230 70-100 136-197 137-294 3-171-167-414-338-657v-1l97-106zM12197 19883c187 267 374 533 370 767-2 156-83 273-168 397-44 64-89 131-121 202-40 90-61 192-64 291-3 105 13 207 45 291 65 166 200 269 267 321l73 55-67 138-72-55c-78-60-235-180-316-388-41-108-62-237-58-368 3-124 29-252 80-364 37-84 88-157 136-228 70-102 135-198 137-295 3-171-168-415-338-657v-1l96-106z"
          className="fill stroke1 "
          style={{
            strokeWidth: 579.675,
            fillRule: "nonzero",
          }}
        />
        <path
          d="m702 14705 20885-8 29 3244-20866 20-48-3256zm5568-2431c455-1238 1554-2641 1825-3684l5582-10c339 322 1864 3207 2027 3691l-9434 3zm9614-1342c4520 2 2346-102 4537 2016 458 442 432 316 647 927l-19780 1c188-493 163-393 483-791 1905-2364 977-1961 4206-1973-246 856-703 956-669 1921l11343 47c49-1039-478-1339-767-2148zM8368 827l5268 18-5 6818-5311-49 48-6787zm-1894 9410c-2429 261-2955-530-3933 749-739 965-1463 1790-2196 2736-489 631-314 1410-315 2533 0 3200-667 2537 4515 2538 1923 0 17148 243 17553-160 346-375 241-3661 201-4162-61-781-912-1565-1569-2396-425-538-1244-1882-1906-1988-892-142-2455 21-3445-15-1112-2122-1069-1301-1069-4489 1-1334 113-4500-76-5583L7739 66c-179 1288-58 4303-56 5841 2 1886 155 2314-1209 4330z"
          style={{
            fill: "#000",
          }}
          className="fill"
        />
        <path
          d="M13653 17332v-1869h385v1869zM15475 17332v-1869h387v1869zM18207 15524c203 0 388 105 522 273 134 169 217 401 217 657s-83 488-217 657-319 273-522 273c-204 0-389-104-523-273s-217-401-217-657 83-488 217-657c134-168 319-273 523-273zm250 615c-64-80-153-129-250-129-98 0-187 49-251 129s-103 192-103 315 39 235 103 315 153 130 251 130c97 0 186-50 250-130 63-80 103-192 103-315s-40-235-103-315z"
          className="stroke1 "
          style={{
            strokeWidth: 579.675,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
